import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_CONFIG } from '@constants';

const useGameCard = ({ checkData }) => {
  const navigate = useNavigate();

  const open = useCallback(() => {
    navigate(`${APP_CONFIG.BASE_URL}/gamecard/${checkData?.id}`, {
      replace: true,
    });
  }, [navigate, checkData?.id]);

  return { open };
};

export default useGameCard;
